import React, { useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import UpgradesButton from "../../assets/icons/upgrades.svg2";
import MyProduct from "./MyProduct";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function AvailableUpgrades() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [products, setProducts] = useState(["1", "2"]);
  const [nextRenewal, setNextRenewal] = useState("28/07/24");
  const [accountStatus, setAccountStatus] = useState("Good");

  const [avaibleCredits, setavaibleCredits] = useState("155,88");
  const availableProducts = [
    {
      id: "1",

      title: "Product Title One",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum beatae molestiae sed ullam qui ",
      price: "2.99",
    },
    {
      id: "2",
      title: "Product Title Two",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum beatae molestiae sed ullam qui ",
      price: "5.99",
    },
    {
      id: "3",
      title: "Product Title Three",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum beatae molestiae sed ullam qui ",
      price: "12.99",
    },
    {
      id: "4",
      title: "Product Title Four",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum beatae molestiae sed ullam qui ",
      price: "8.99",
    },
  ];

  return (
    <>
      <Button
        className="btn btn-light rounded-pill w-100  fw-bold text-purple text-nowrap p-1 py-0 "
        style={{ fontSize: "0.6rem" }}
        onClick={handleShow}
      >
        SEE UPGRADES <UpgradesButton className="m-1" width={15} />
      </Button>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        style={{ width: 700 }}
      >
        <Offcanvas.Header closeButton className="bg-colored-reverse text-white">
          <Offcanvas.Title className="fw-bold">
            Available Upgrades
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="bg-purple-gradient p-5">
          <div className="fw-bold text-center d-flex flex-column align-items-center">
            <div className="bg-secondary bg-opacity-25 rounded-circle p-2">
              <UpgradesButton width={50} />
            </div>
            <div className="text-secondary fs-5 mb-2">
              Lorem, ipsum dolor sit amet consectetur adipisicing elit.
            </div>
          </div>

          <hr className="border-secondary" />
          <div className="d-flex justify-content-between bg-icon p-3 rounded-3 mb-5">
            <div className="border-end pe-5 border-secondary border-opacity-50">
              <div className="fw-bold">Account Status:</div>
              <div className="ms-2 d-flex">
                <div className="mx-1 px-1">
                  <FontAwesomeIcon
                    icon={faCircle}
                    size="2xs"
                    className={`${
                      accountStatus === "Good" ? "text-light-green" : ""
                    }${accountStatus === "bad" ? "text-warning" : ""}`}
                  />
                </div>
                <div>
                  <div>
                    <span className="fw-bold">{accountStatus}:</span>
                    <span className="fs-6">In Credit</span>
                  </div>
                  <div>
                    <span className="fw-bold">Next renewal:</span>
                    <span>{nextRenewal}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="border-end px-4 border-secondary border-opacity-50">
              <div>
                <div className="fw-bold">Avaible Credits:</div>
                <div className="text-blue fw-bold fs-2">£{avaibleCredits}</div>
              </div>
            </div>

            <div className="px-4">
              <button className="bg-colored-reverse text-white text-nowrap rounded-pill px-3 py-2 mt-3 me-3  border-0 fw-bold">
                <FontAwesomeIcon icon={faPlus} className="me-1" />
                ADD FUNDS
              </button>
            </div>
          </div>
          <div className="d-flex align-items-center  mb-5">
            <span className="fw-bold text-nowrap me-2"> Filter by:</span>
            <div className="me-2">
              <Form.Select
                aria-label="Default select example"
                className="text-secondary "
              >
                <option className="text-secondary" disabled>
                  Service type
                </option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </Form.Select>
            </div>
            <div>
              <Form.Select
                aria-label="Default select example"
                className="text-secondary"
              >
                <option className="text-secondary" disabled>
                  Category
                </option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </Form.Select>
            </div>
            <div className="flex-grow-1"></div>
          </div>
          <div className="py-2"></div>
          {availableProducts.map((product) => (
            <MyProduct
              key={product.id}
              product={product}
              products={products}
              setProducts={setProducts}
            />
          ))}
          <div className="text-center p-4">
            <div className="fw-bold">
              You've selected
              <span className="text-blue ms-1">{products.length} </span>products
              to purchase
            </div>
            <div>
              <Link
                to="/checkout"
                className=" btn nav-color text-white rounded-pill px-5 py-3 mt-5 border-0"
              >
                Continue to checkout
              </Link>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default AvailableUpgrades;
